import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BackArrow } from "../../../components/CustomMiscellaneous/BackArrow";
import { genericGet } from "../../../services/api.service";
import OrcamentosDisplay from "./OrcamentoDisplay/index";
import OrcamentosForm from "./OrcamentosForm/index";

export default function Orcamento() {
	const location = useLocation();
	const navigate = useNavigate();
	const [isEditing, setIsEditing] = useState(false);

	const {
		data: orcamento,
		isLoading,
		refetch,
	} = useQuery({
		queryKey: ["orcamento"],
		queryFn: async () => {
			return await genericGet(location.pathname);
		},
	});

	if (!orcamento) return null;

	return (
		<div>
			<BackArrow onClick={() => navigate(-1)} />
			{isEditing ? <OrcamentosForm refetch={refetch} orcamento={orcamento} onCancel={() => setIsEditing(false)} /> : <OrcamentosDisplay orcamento={orcamento} setEditing={setIsEditing} />}
		</div>
	);
}
